// Remote Punch — every user-facing text, Arabic and English.

export const remotePunchText = {
  ar: {
    // employee attendance page
    badge: "بصمة عن بُعد",
    badgeHint: "مسموح لك تبصم من أي مكان من الموبايل أو التابلت.",
    until: "لحد",
    consentTitle: "البصمة عن بُعد",
    consentBody: "تم تفعيل البصمة عن بُعد لك.",
    consentAccept: "موافق",
    consentRequired: "لازم توافق على رسالة البصمة عن بُعد الأول.",
    deviceBlocked: "البصمة عن بُعد مسموحة من الموبايل أو التابلت بس. افتح النظام من موبايلك.",
    accuracyLow: (acc, limit) =>
      `دقة موقعك دلوقتي ± ${acc} متر والمطلوب ± ${limit} متر أو أقل. افتح الواي فاي وقرّب من الشباك واضغط تحديث الموقع.`,
    yourAccuracy: "دقة موقعك",
    meters: "متر",
    refreshLocation: "تحديث الموقع",
    errors: {
      REMOTE_LOCATION_REQUIRED: "لازم نعرف موقعك عشان تبصم عن بُعد. شغّل الموقع (Location) وحاول تاني.",
      REMOTE_DEVICE_NOT_ALLOWED: "البصمة عن بُعد مسموحة من الموبايل أو التابلت بس.",
      REMOTE_ACCURACY_TOO_LOW: "دقة موقعك ضعيفة. افتح الواي فاي وقرّب من الشباك وجرّب تاني.",
    },

    // map / pin
    quality: { excellent: "ممتازة", good: "جيدة", fair: "مقبولة", poor: "ضعيفة", unknown: "غير معروفة" },
    recenter: "توسيط الخريطة",
    copyCoords: "نسخ الإحداثيات",
    copied: "اتنسخت",
    currentLocation: "موقعك الحالي",
    locatingArea: "بنحدد اسم المنطقة…",
    areaUnknown: "مش قادرين نحدد اسم المنطقة دلوقتي، بس موقعك متسجل.",
    consentPoints: [
      "تقدر تسجّل حضورك وانصرافك من أي مكان من الموبايل أو التابلت.",
      "موقعك بيتسجل لحظة الضغط على تسجيل الحضور أو الانصراف بس.",
      "مش هيتم تتبعك طول اليوم.",
    ],
    summaryRemote: (n) => `${n} موظف عن بُعد`,
    summaryActive: (n) => `${n} ساري النهارده`,
    summaryAccuracy: (m) => `حد الدقة ± ${m} متر`,
    summaryMonitoring: (date) => `وضع المراقبة لحد ${date}`,
    summaryMonitoringPending: "وضع المراقبة هيبدأ مع أول تفعيل",
    summaryEnforcing: "الرفض شغال",
    showingFirst: (n) => `معروض أول ${n} موظف — استخدم البحث للوصول لأي موظف.`,
    noGroupsHint: "اعمل مجموعة من صفحة المجموعات وبعدين فعّل لها البصمة عن بُعد من هنا.",
    notRemote: "مش مفعّل",
    pinTitle: "مكان البصمة",
    checkIn: "تسجيل حضور",
    checkOut: "تسجيل انصراف",
    area: "المنطقة",
    office: "داخل موقع العمل",
    areaPending: "جاري تحديد اسم المنطقة…",
    accuracy: "الدقة",
    coordinates: "الإحداثيات",
    openInGoogleMaps: "افتح في Google Maps",
    monitoringPunch: "اتسجلت أثناء وضع المراقبة",
    close: "إغلاق",
    mapLoadFailed: "تعذّر تحميل الخريطة.",
    showOnMap: "اعرض مكان البصمة",
    exportArea: "المنطقة",
    exportMap: "رابط الخريطة",

    // management modal
    manageButton: "البصمة عن بُعد",
    manageTitle: "البصمة عن بُعد",
    manageSubtitle: "الموظفين اللي يقدروا يبصموا من أي مكان من الموبايل أو التابلت.",
    tabEmployees: "الموظفين",
    tabGroups: "المجموعات",
    search: "ابحث بالاسم أو الكود…",
    onlyRemote: "اللي مفعّل لهم بس",
    allCompanies: "كل الشركات",
    allDepartments: "كل الأقسام",
    employee: "الموظف",
    group: "المجموعة",
    members: "عضو",
    remote: "عن بُعد",
    from: "من",
    to: "إلى",
    noEnd: "بدون نهاية",
    source: "المصدر",
    sourceManual: "يدوي",
    sourceGroup: (name) => `من مجموعة ${name || ""}`.trim(),
    consentDone: "وافق على رسالة الخصوصية",
    consentPending: "لسه ما وافقش",
    inactiveToday: "مش ساري النهارده",
    save: "حفظ",
    saving: "جاري الحفظ…",
    saved: "تم الحفظ",
    edit: "تعديل",
    cancel: "إلغاء",
    enable: "تفعيل",
    disable: "إيقاف",
    noEmployees: "مفيش موظفين",
    noGroups: "مفيش مجموعات",
    loading: "جاري التحميل…",
    groupHint:
      "تفعيل المجموعة بيفعّل البصمة عن بُعد لكل أعضائها، وأي عضو جديد هيتضاف للمجموعة ياخدها تلقائي. اللي مفعّل لهم يدوي مش بيتأثروا.",
    groupApplied: (n) => `اتطبّق على ${n} موظف`,
    groupReleased: (n) => `اتوقف عن ${n} موظف`,
    error: "خطأ",
    success: "تم",
    dateRangeInvalid: "تاريخ النهاية لازم يكون بعد تاريخ البداية.",

    // alert modal (superadmin)
    alertTitle: "تنبيه بصمة عن بُعد",
    alertEmployee: "الموظف",
    alertCompany: "الشركة",
    alertClient: "العميل",
    whatHappened: "إيه اللي حصل",
    thePunch: "البصمة",
    accepted: "اتقبلت",
    refused: "اترفضت",
    monitoringMode: "وضع المراقبة",
    rejectReason: "سبب الرفض",
    location: "المكان",
    device: "الجهاز",
    browser: "المتصفح",
    ipAddress: "عنوان IP",
    deviceTimezone: "توقيت الجهاز",
    otherToday: "حالات تانية لنفس الموظف النهارده",
    time: "الوقت",
    signals: {
      LAPTOP: {
        title: "محاولة بصمة من لابتوب أو كمبيوتر",
        body: "البصمة عن بُعد مسموحة من الموبايل أو التابلت بس، والمحاولة دي جت من متصفح كمبيوتر.",
      },
      IDENTICAL_COORDINATES: {
        title: "نفس الإحداثيات بالظبط في يوم سابق",
        body: "الـ GPS الحقيقي بيتحرك شوية كل مرة، فتطابق الإحداثيات بالظبط مع بصمة في يوم تاني غالباً معناه إن الموقع متزوّر (Fake GPS أو DevTools).",
        previous: "البصمة السابقة",
      },
      TIMEZONE_MISMATCH: {
        title: "توقيت الجهاز مختلف عن توقيت مصر",
        body: "الـ GPS بيقول إن الموظف في مصر، بس الجهاز متظبط على توقيت بلد تانية. ده ممكن يكون علامة على VPN أو تزوير للموقع.",
      },
    },
    rejectCodes: {
      REMOTE_LOCATION_REQUIRED: "مفيش موقع",
      REMOTE_DEVICE_NOT_ALLOWED: "الجهاز مش موبايل أو تابلت",
      REMOTE_ACCURACY_TOO_LOW: "دقة الموقع ضعيفة",
    },
    deviceClass: { mobile: "موبايل", tablet: "تابلت", desktop: "لابتوب / كمبيوتر" },
    loadFailed: "تعذّر تحميل التنبيه.",

    // superadmin settings
    settingsTitle: "إعدادات البصمة عن بُعد",
    settingsSubtitle: "خاصة بالشركة دي بس — كل شركة ليها إعداداتها.",
    accuracyLimit: "حد دقة الموقع (متر)",
    accuracyLimitHint: "أي بصمة دقتها أسوأ من كده هتترفض بعد ما وضع المراقبة يخلص.",
    monitoringDays: "مدة وضع المراقبة (أيام)",
    monitoringDaysHint: "أثناء المراقبة البصمة بتتقبل دايماً (إلا لو مفيش موقع) والتنبيهات بتتبعت.",
    monitoringStatusOn: (date) => `وضع المراقبة شغال لحد ${date}`,
    monitoringStatusNotStarted: "وضع المراقبة هيبدأ أول ما حد يتفعّل له البصمة عن بُعد.",
    monitoringStatusOff: (date) => `الرفض شغال من ${date}`,
    endMonitoring: "إنهاء المراقبة دلوقتي",
    restartMonitoring: "بدء مراقبة جديدة",
    confirmEnd: "متأكد؟ البصمات من لابتوب أو بدقة ضعيفة هتترفض من دلوقتي.",
    confirmRestart: "هتبدأ فترة مراقبة جديدة من النهارده. متأكد؟",
    alertAccount: "اللي يستقبلوا التنبيهات",
    alertAccountNone: "مفيش حد متحدد — التنبيهات هتتسجل بس من غير ما توصل لحد.",
    alertSearch: "ابحث بالاسم أو الكود أو الإيميل…",
    alertSearchEmpty: "مفيش نتايج",
    alertMax: (n) => `أقصى عدد ${n} أشخاص.`,
    removeRecipient: "شيل",
    alertAccountHint: "سوبر أدمن أو أي حد ليه أكونت في الشركة دي. كلهم بيوصلهم إشعار لكل محاولة، وإيميل واحد في اليوم لكل موظف.",
    featureEnabled: "تفعيل البصمة عن بُعد للشركة دي",
    featureEnabledHint: "لو اتقفلت، زراير البصمة عن بُعد بتختفي من كل الصفحات والبصمة بترجع زي الأول. الموظفين المفعّل لهم بيفضلوا محفوظين لحد ما تفتحها تاني.",
    // management modal — summary tiles, row details, editor
    tileRemote: "موظفين عن بُعد",
    tileActive: "ساري النهارده",
    tileAccuracy: "حد الدقة",
    tileMode: "الوضع الحالي",
    meters: "متر",
    modeMonitoring: (date) => `مراقبة لحد ${date}`,
    modePending: "مراقبة (لسه ما بدأتش)",
    modeEnforcing: "الرفض شغال",
    periodLabel: "الفترة",
    consentLabel: "رسالة الخصوصية",
    allowRemote: "السماح بالبصمة عن بُعد",
    allowRemoteHint: "التواريخ اختيارية — من غير تاريخ نهاية هيفضل مفعّل لحد ما تقفله.",
  },

  en: {
    badge: "Remote punch",
    badgeHint: "You can check in from anywhere, from a phone or tablet.",
    until: "until",
    consentTitle: "Remote punch",
    consentBody: "Remote punch has been enabled for you.",
    consentAccept: "OK",
    consentRequired: "Please accept the remote punch notice first.",
    deviceBlocked: "Remote check-in is only allowed from a phone or tablet. Open the system on your phone.",
    accuracyLow: (acc, limit) =>
      `Your location accuracy is ± ${acc} m; ± ${limit} m or better is required. Turn on Wi-Fi, move near a window and refresh your location.`,
    yourAccuracy: "Your accuracy",
    meters: "m",
    refreshLocation: "Refresh location",
    errors: {
      REMOTE_LOCATION_REQUIRED: "Your location is required to check in or out remotely. Turn on location and try again.",
      REMOTE_DEVICE_NOT_ALLOWED: "Remote check-in and check-out are only allowed from a phone or tablet.",
      REMOTE_ACCURACY_TOO_LOW: "Your location isn't accurate enough. Turn on Wi-Fi, move near a window and try again.",
    },

    quality: { excellent: "Excellent", good: "Good", fair: "Fair", poor: "Poor", unknown: "Unknown" },
    recenter: "Recenter map",
    copyCoords: "Copy coordinates",
    copied: "Copied",
    currentLocation: "Your current location",
    locatingArea: "Finding the area name…",
    areaUnknown: "The area name isn't available right now, but your location is recorded.",
    consentPoints: [
      "You can check in and out from anywhere, from a phone or tablet.",
      "Your location is recorded only at the moment you press Check In or Check Out.",
      "You are never tracked during the day.",
    ],
    summaryRemote: (n) => `${n} remote employee${n === 1 ? "" : "s"}`,
    summaryActive: (n) => `${n} in effect today`,
    summaryAccuracy: (m) => `Accuracy limit ± ${m} m`,
    summaryMonitoring: (date) => `Monitoring until ${date}`,
    summaryMonitoringPending: "Monitoring starts with the first remote employee",
    summaryEnforcing: "Refusals active",
    showingFirst: (n) => `Showing the first ${n} employees — use search to find anyone.`,
    noGroupsHint: "Create a group in Groups Management, then enable remote punch for it here.",
    notRemote: "Off",
    pinTitle: "Punch location",
    checkIn: "Check-in",
    checkOut: "Check-out",
    area: "Area",
    office: "At a work location",
    areaPending: "Finding the area name…",
    accuracy: "Accuracy",
    coordinates: "Coordinates",
    openInGoogleMaps: "Open in Google Maps",
    monitoringPunch: "Recorded during monitoring mode",
    close: "Close",
    mapLoadFailed: "The map couldn't be loaded.",
    showOnMap: "Show punch location",
    exportArea: "Area",
    exportMap: "Map link",

    manageButton: "Remote Punch",
    manageTitle: "Remote Punch",
    manageSubtitle: "Employees who may check in from anywhere, from a phone or tablet.",
    tabEmployees: "Employees",
    tabGroups: "Groups",
    search: "Search by name or code…",
    onlyRemote: "Remote only",
    allCompanies: "All companies",
    allDepartments: "All departments",
    employee: "Employee",
    group: "Group",
    members: "members",
    remote: "Remote",
    from: "From",
    to: "To",
    noEnd: "No end date",
    source: "Source",
    sourceManual: "Manual",
    sourceGroup: (name) => `From group ${name || ""}`.trim(),
    consentDone: "Accepted the privacy notice",
    consentPending: "Hasn't accepted yet",
    inactiveToday: "Not in effect today",
    save: "Save",
    saving: "Saving…",
    saved: "Saved",
    edit: "Edit",
    cancel: "Cancel",
    enable: "Enable",
    disable: "Disable",
    noEmployees: "No employees",
    noGroups: "No groups",
    loading: "Loading…",
    groupHint:
      "Enabling a group makes all its members remote, and anyone added to the group later gets it automatically. Employees enabled manually are not affected.",
    groupApplied: (n) => `Applied to ${n} employee(s)`,
    groupReleased: (n) => `Removed from ${n} employee(s)`,
    error: "Error",
    success: "Done",
    dateRangeInvalid: "The end date must be after the start date.",

    alertTitle: "Remote punch alert",
    alertEmployee: "Employee",
    alertCompany: "Company",
    alertClient: "Client",
    whatHappened: "What happened",
    thePunch: "The punch",
    accepted: "Accepted",
    refused: "Refused",
    monitoringMode: "Monitoring mode",
    rejectReason: "Refused because",
    location: "Location",
    device: "Device",
    browser: "Browser",
    ipAddress: "IP address",
    deviceTimezone: "Device time zone",
    otherToday: "Other alerts for this employee today",
    time: "Time",
    signals: {
      LAPTOP: {
        title: "Punch attempt from a laptop / desktop",
        body: "Remote punch is only allowed from a phone or tablet; this attempt came from a desktop browser.",
      },
      IDENTICAL_COORDINATES: {
        title: "Exactly the same coordinates as an earlier day",
        body: "A real GPS moves a little every time. Coordinates identical to a punch on another day usually mean a faked location (fake GPS app or DevTools).",
        previous: "Earlier punch",
      },
      TIMEZONE_MISMATCH: {
        title: "Device clock set to another country",
        body: "The GPS says the employee is in Egypt, but the device is set to another country's time — a possible sign of a VPN or a faked location.",
      },
    },
    rejectCodes: {
      REMOTE_LOCATION_REQUIRED: "No location",
      REMOTE_DEVICE_NOT_ALLOWED: "Not a phone or tablet",
      REMOTE_ACCURACY_TOO_LOW: "Location accuracy too low",
    },
    deviceClass: { mobile: "Phone", tablet: "Tablet", desktop: "Laptop / desktop" },
    loadFailed: "The alert couldn't be loaded.",

    settingsTitle: "Remote Punch settings",
    settingsSubtitle: "For this company only — each company has its own.",
    accuracyLimit: "Location accuracy limit (m)",
    accuracyLimitHint: "Punches less accurate than this are refused once monitoring ends.",
    monitoringDays: "Monitoring period (days)",
    monitoringDaysHint: "While monitoring, punches are always accepted (unless there is no location) and alerts are still sent.",
    monitoringStatusOn: (date) => `Monitoring until ${date}`,
    monitoringStatusNotStarted: "Monitoring starts the first time someone is made remote.",
    monitoringStatusOff: (date) => `Refusals active since ${date}`,
    endMonitoring: "End monitoring now",
    restartMonitoring: "Start a new monitoring period",
    confirmEnd: "Are you sure? Laptop and low-accuracy punches will be refused from now on.",
    confirmRestart: "A new monitoring period will start today. Are you sure?",
    alertAccount: "Who receives alerts",
    alertAccountNone: "Nobody yet — alerts are recorded but not sent to anyone.",
    alertSearch: "Search by name, code or email…",
    alertSearchEmpty: "No results",
    alertMax: (n) => `Up to ${n} people.`,
    removeRecipient: "Remove",
    alertAccountHint: "A superadmin or anyone with an account in this company. Each gets a notification for every attempt, and at most one email per employee per day.",
    featureEnabled: "Enable Remote Punch for this company",
    featureEnabledHint: "When off, the Remote Punch buttons disappear from every page and punches work as before. Remote employees are kept until you switch it back on.",
    // management modal — summary tiles, row details, editor
    tileRemote: "Remote employees",
    tileActive: "In effect today",
    tileAccuracy: "Accuracy limit",
    tileMode: "Current mode",
    meters: "m",
    modeMonitoring: (date) => `Monitoring until ${date}`,
    modePending: "Monitoring (not started)",
    modeEnforcing: "Refusals active",
    periodLabel: "Period",
    consentLabel: "Privacy notice",
    allowRemote: "Allow remote punch",
    allowRemoteHint: "Dates are optional — without an end date it stays on until you switch it off.",
  },
};

export const rpText = (language) => remotePunchText[language] || remotePunchText.en;
